import type { FilterStatus } from "@/types/common/filters";
import { cn } from "@/utils/theme";
import { Checkbox } from "@elaniintc/goes-design-system";

interface FilterStateProps {
  states: FilterStatus[];
  onStatesChange: (value: string) => void;
}
export default function FilterStatus({
  states,
  onStatesChange,
}: FilterStateProps) {
  const areAllSelected = states.every(({ value }) => value);
  const isAtLeastOneSelected = states.filter(({ value }) => value).length > 0;
  return (
    <div className="flex flex-col space-y-6 p-6 overflow-y-auto h-full">
      <div className="flex justify-between w-min-[332px] mr-3">
        <h5 className="text-heading text-xl font-semibold">Estado</h5>
        <Checkbox
          className="w-5 h-5 focus:ring-1! font-bold cursor-pointer"
          checked={isAtLeastOneSelected}
          onChange={() => onStatesChange(areAllSelected ? "none" : "all")}
          icon={!areAllSelected && isAtLeastOneSelected ? "-" : undefined}
        />
      </div>
      <div className="flex flex-col space-y-0.5">
        {states.map((item) => (
          <StateItem
            key={item.label}
            label={item.label}
            value={item.value}
            field={item.field}
            onStatesChange={onStatesChange}
          />
        ))}
      </div>
    </div>
  );
}

const StateItem = ({
  label,
  value,
  onStatesChange,
}: FilterStatus & { onStatesChange: (value: string) => void }) => {
  return (
    <div
      onClick={() => onStatesChange(label)}
      className={cn(
        "flex w-full justify-between py-2 px-3 font-semibold font-geist text-base leading-3xl rounded-lg cursor-pointer",
        value
          ? "border border-contextual-action-quiet text-action bg-surface-action-accent"
          : "border border-neutral-quiet text-body bg bg-transparent",
      )}
    >
      <span>{label}</span>
      <Checkbox
        className="w-5 h-5 focus:ring-1! font-bold cursor-pointer"
        checked={value}
        onChange={() => onStatesChange(label)}
      />
    </div>
  );
};
